'use client';

import { useEffect } from 'react';

import { usePortalStore } from '../../store/usePortalStore';
import { usePathnameMethod } from '../../utils/hook/usePathnameMethod';

/**
 * 포탈 관련 로직을 관리하는 컴포넌트
 * - 포탈 children 렌더링
 * - 페이지 이동 시 포탈 자동 닫기
 */
const LayoutPortal = () => {
  const portalChildren = usePortalStore.use.children();
  const closePortal = usePortalStore.use.closePortal();
  const { pathname, search } = usePathnameMethod();

  // 페이지 이동 시 포탈 닫기
  useEffect(() => {
    return () => {
      closePortal();
    };
  }, [pathname, search, closePortal]);

  return <>{portalChildren}</>;
};

export default LayoutPortal;
